import $ from 'jquery';
import '../../node_modules/core-js/features/object/assign';
import '../../node_modules/core-js/features/promise';
import '../../node_modules/core-js/features/array/find';
import breakpoint from '../scripts/breakpoint';
import tippy from 'tippy.js';

$.addInit(function(context){
	var base = '[rel="tooltip"]';
	$(base, context).each(function(i, el){
		var instance = tippy(el, {
			content: function content(reference) {
				return reference.getAttribute('data-text');
			},
			allowHTML: true,
			theme: 'white',
			interactive: true,
			appendTo: function appendTo() {
				return document.body;
			},
			maxWidth: 586,
			placement: 'right',
			boundary: 'viewport',
			zIndex: 8,
			lazy: false,
			onShow: function(instance) {
				
			},
		});

		breakpoint(null, 'lg')
			.onmatch(function(){
				instance.disable();
			})
			.onmismatch(function() {
				instance.enable();
			});
	});
});
